import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { SessionService } from '@core/services/session.service';
import { ClipboardService } from '@core/services/clipboard.service';
import { ContextMenuService } from '@core/services/context-menu.service';
import { Skin } from '@core/interfaces/skin.interface';
import { SkinsListComponent } from '@core/components/skins-list/skins-list.component';
import { Jackpot } from '@features/games/jackpot/interfaces/jackpot.interface';
import { User } from '@core/interfaces/user.interface';
import { DecimalPipe } from '@angular/common';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { JackpotBet } from '@features/games/jackpot/interfaces/jackpot.interface';
import { isMenuless } from '@core/utils/bot-player.util';

@Component({
  selector: 'app-jackpot-skins-modal',
  imports: [
    PlayerRowComponent,
    SkinsListComponent,
    DecimalPipe,
    BalanceIconComponent,
  ],
  templateUrl: './jackpot-skins-modal.component.html',
  styleUrl: './jackpot-skins-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class JackpotSkinsModalComponent {
  public sessionService = inject(SessionService);
  public contextMenuService = inject(ContextMenuService);
  public clipboardService = inject(ClipboardService);
  protected readonly isMenuless = isMenuless;

  skins = input<Skin[]>([]);
  user = input<User | null>(null);
  color = input<JackpotBet['user_color']>();
  game = input.required<Pick<Jackpot, 'gameid'>>();
  totalValue = computed(() => {
    return this.skins().reduce((acc, skin) => acc + skin.price, 0);
  });
}
